import { CNavGroup, CNavItem } from "@coreui/react";
import Icon from "components/icon/Icon";
import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom"
import { SERVER_ROUTE } from "utils/constants";
import { useAppDispatch } from "app/hooks";
import { invalidateEvaluacionCache } from "features/Alumno/evaluacionSlice";

export const AppSidebarNav = ({ items }: any) => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const navItem = (mod: any, index: any) => {
        const targetPath = `${SERVER_ROUTE}/${mod.etiqueta}`;
        const isActive = location.pathname === targetPath;

        const handleClick = (e: React.MouseEvent) => {
            e.preventDefault();

            if (mod.etiqueta === 'alumno/evaluaciones' || mod.etiqueta === 'alumno/encuestas') {
                dispatch(invalidateEvaluacionCache());
            }

            navigate(targetPath);
        };

        return (
            <CNavItem
                key={mod.idOpcion}
                to={targetPath}
                data-title={mod.nombre}
                className={`mt-1 mb-2 ${isActive ? 'active' : ''}`}
                onClick={handleClick}
                style={{ cursor: 'pointer' }}
            >
                <Icon icono={mod.icono} size={1} className='nav-icon' />
                <span className="ml-4">{mod.nombre}</span>
            </CNavItem>
        )
    }

    const navGroup = (mod: any, index: any) => {
        return (
            <CNavGroup
                idx={String(index)}
                key={index}
                data-title={mod.nombre}
                toggler={<>
                    <Icon icono={mod.icono} size={1} className='nav-icon' />
                    <span>{mod.nombre}</span>
                </>}
                visible={location.pathname.startsWith(`${SERVER_ROUTE}/${mod.etiqueta}`)}
            >
                {mod.opciones?.map((opt: any, index: any) =>
                    opt.opciones ? navGroup(opt, index) : navItem(opt, index),
                )}
            </CNavGroup>
        )
    }

    return (
        <React.Fragment>
          {items &&
            items.map((item: any, index: any) => (item.opciones ? navGroup(item, index) : navItem(item, index)))}
        </React.Fragment>
    )
}